// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3nU7v","wrapper":"Section_wrapper__1B46l","button":"Section_button__n4p9S","title":"Section_title__23bR8","interactive":"Section_interactive__16ouQ"};